import { Component } from '@angular/core';
import { ItemListContainerBase } from '@fi-app/core/item-list-container-base';
import { IChecklistListStateModel } from '../../checklist';
import { ChecklistListDataModel } from '../checklist-list-data.model';

@Component({
    selector: 'fi-checklist-list-container',
    template: `
        <fi-checklist-list-view [checklistListStateModel]="checklistListStateModel" [listData]="ListData">
        </fi-checklist-list-view>
    `,
    styleUrls: ['./checklist-list-container.component.scss'],
    standalone: false,
})
export class ChecklistListContainerComponent extends ItemListContainerBase {
    checklistListStateModel: IChecklistListStateModel;
    ListData: ChecklistListDataModel;
}
